module.exports = __webpack_public_path__ + "img/users.dce69c17.svg";